import categoriesService from '@/modules/categories/service/categoriesService';

const state = {
  isLoading: false,
  categoriesServices: [],
  didFetchServices: false,
};

const getters = {
  categoriesServices: (state) => state.categoriesServices,
  isLoading: (state) => state.isLoading,
  didFetchServices: (state) => state.didFetchServices,
};

const mutations = {
  setCategoriesServices(state, serviceList) {
    state.categoriesServices = serviceList;
  },
  setDidFetchServices(state, didFetchServices) {
    state.didFetchServices = didFetchServices;
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const actions = {
  async loadServices({ commit }) {
    commit('setIsLoading', true);
    try {
      commit('setCategoriesServices', await categoriesService.getAllServices());
      commit('setDidFetchServices', true);
    } finally {
      commit('setIsLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
